import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: " p-d-flex p-flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Card = _resolveComponent("Card")

  return (_ctx.chart)
    ? (_openBlock(), _createBlock(_component_Card, {
        key: 0,
        class: "p-m-2"
      }, {
        header: _withCtx(() => [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
            start: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.typeOfDocument')), 1)
            ]),
            _: 1
          })
        ]),
        content: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.kpiDocumentDesignerDocumentTypeCardDescriptor.documentTypeOptions, (option, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "field-radiobutton p-mx-2",
                key: index
              }, [
                _createVNode(_component_RadioButton, {
                  id: option.value,
                  value: option.value,
                  modelValue: _ctx.chart.model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.chart.model = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('documentTypeChanged')))
                }, null, 8, ["id", "value", "modelValue"]),
                _createVNode("label", {
                  for: option.value,
                  class: "p-ml-2"
                }, _toDisplayString(_ctx.$t(option.label)), 9, ["for"])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}